module.exports = __webpack_public_path__ + "static/media/videobg.15808945.png";